export default __webpack_public_path__ + "static/media/thumbnail.b0b8f40b.png";